var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiper-container" },
    [
      _c(
        "swiper",
        { ref: "heroCarouselDesktop", attrs: { options: _vm.desktopOptions } },
        _vm._l(_vm.slides, function(slide, index) {
          return _c("swiper-slide", { key: index }, [
            slide.enableCta
              ? _c(
                  "a",
                  {
                    staticClass: "hero-banner",
                    class: [
                      _vm.layoutHorizontal,
                      _vm.layoutVertical,
                      _vm.textAlign,
                      _vm.rootTextBox
                    ],
                    style: _vm.slideContainerStyle(slide),
                    attrs: { href: slide.ctaUrl }
                  },
                  [
                    _c("div", {
                      staticClass: "hero-banner__bg",
                      style: _vm.backgroundImageStyles(slide)
                    }),
                    _vm.heroSchema.enableTextBox
                      ? _c("div", {
                          staticClass: "hero-banner__text-box-bg",
                          style: _vm.textBoxBgStyle(slide)
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "hero-banner__content-container" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "hero-banner__content",
                            class: [_vm.contentClass, _vm.heroSchema.layout],
                            style: _vm.contentStyle
                          },
                          [
                            _c("div", {
                              staticClass: "hero-banner__overlay",
                              class: slide.overlayColor,
                              style: {
                                opacity: 0 + slide.overlayOpacity,
                                backgroundColor: slide.overlayBgColor
                              }
                            }),
                            slide.preHeading
                              ? _c(
                                  "h4",
                                  {
                                    staticClass: "preheader",
                                    class: slide.preHeadingColor
                                  },
                                  [_vm._v(_vm._s(slide.preHeading))]
                                )
                              : _vm._e(),
                            slide.heading
                              ? _c(
                                  "h2",
                                  {
                                    staticClass: "h1",
                                    class: slide.headingColor
                                  },
                                  [_vm._v(_vm._s(slide.heading))]
                                )
                              : _vm._e(),
                            slide.subHeading
                              ? _c(
                                  "h3",
                                  {
                                    staticClass: "subheader",
                                    class: slide.subHeadingColor
                                  },
                                  [_vm._v(_vm._s(slide.subHeading))]
                                )
                              : _vm._e(),
                            slide.copy
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "body-md hero-banner__body-copy",
                                    class: slide.copyColor
                                  },
                                  [_vm._v(_vm._s(slide.copy))]
                                )
                              : _vm._e(),
                            slide.ctaText
                              ? _c(
                                  "div",
                                  { staticClass: "hero-banner__cta-wrapper" },
                                  [
                                    slide.ctaLayout.includes("button")
                                      ? _c(
                                          "v-button",
                                          {
                                            staticClass: "hero-banner__cta",
                                            class: slide.ctaLayout,
                                            style: _vm.ctaStyles(slide),
                                            attrs: { href: slide.ctaUrl }
                                          },
                                          [_vm._v(_vm._s(slide.ctaText))]
                                        )
                                      : _vm._e(),
                                    slide.ctaLayout.includes("link")
                                      ? _c(
                                          "v-link",
                                          {
                                            staticClass: "hero-banner__cta",
                                            class: slide.ctaLayout,
                                            attrs: {
                                              href: slide.ctaUrl,
                                              tag: "a"
                                            }
                                          },
                                          [_vm._v(_vm._s(slide.ctaText))]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.heroSchema.enableTextBox
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "hero-carousel__controls-container hero-carousel__controls-container--text-box"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "controls-container",
                                        class: [
                                          _vm.layoutHorizontal,
                                          _vm.layoutVertical,
                                          _vm.textAlign
                                        ],
                                        style: _vm.sliderControlsLayout
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pagination-dots",
                                            style:
                                              _vm.sliderControlsLayoutArrows
                                          },
                                          _vm._l(_vm.slides, function(
                                            slide,
                                            index
                                          ) {
                                            return _c("div", {
                                              key: "dot-" + index,
                                              staticClass: "dot",
                                              class: _vm.dotActive(index),
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.slidePagination(
                                                    index
                                                  )
                                                }
                                              }
                                            })
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "hero-banner",
                    class: [
                      _vm.layoutHorizontal,
                      _vm.layoutVertical,
                      _vm.textAlign,
                      _vm.rootTextBox
                    ],
                    style: _vm.slideContainerStyle(slide)
                  },
                  [
                    _vm.heroSchema.enableTextBox
                      ? _c("div", {
                          staticClass: "hero-banner__text-box-bg",
                          style: _vm.textBoxBgStyle(slide)
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "hero-banner__content-container" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "hero-banner__content",
                            class: [_vm.contentClass, _vm.heroSchema.layout],
                            style: _vm.contentStyle
                          },
                          [
                            _c("div", {
                              staticClass: "hero-banner__overlay",
                              class: slide.overlayColor,
                              style: {
                                opacity: 0 + slide.overlayOpacity,
                                backgroundColor: slide.overlayBgColor
                              }
                            }),
                            slide.preHeading
                              ? _c(
                                  "h4",
                                  {
                                    staticClass: "preheader",
                                    class: slide.preHeadingColor
                                  },
                                  [_vm._v(_vm._s(slide.preHeading))]
                                )
                              : _vm._e(),
                            slide.heading
                              ? _c(
                                  "h2",
                                  {
                                    staticClass: "h1",
                                    class: slide.headingColor
                                  },
                                  [_vm._v(_vm._s(slide.heading))]
                                )
                              : _vm._e(),
                            slide.subHeading
                              ? _c(
                                  "h3",
                                  {
                                    staticClass: "subheader",
                                    class: slide.subHeadingColor
                                  },
                                  [_vm._v(_vm._s(slide.subHeading))]
                                )
                              : _vm._e(),
                            slide.copy
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "body-md hero-banner__body-copy",
                                    class: slide.copyColor
                                  },
                                  [_vm._v(_vm._s(slide.copy))]
                                )
                              : _vm._e(),
                            _vm.heroSchema.enableTextBox
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "hero-carousel__controls-container hero-carousel__controls-container--text-box"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "controls-container",
                                        class: [
                                          _vm.layoutHorizontal,
                                          _vm.layoutVertical,
                                          _vm.textAlign
                                        ],
                                        style: _vm.sliderControlsLayout
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pagination-dots",
                                            style:
                                              _vm.sliderControlsLayoutArrows
                                          },
                                          _vm._l(_vm.slides, function(
                                            slide,
                                            index
                                          ) {
                                            return _c("div", {
                                              key: "dot-" + index,
                                              staticClass: "dot",
                                              class: _vm.dotActive(index),
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.slidePagination(
                                                    index
                                                  )
                                                }
                                              }
                                            })
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _c("div", {
                      staticClass: "hero-banner__overlay",
                      class: slide.overlayColor,
                      style: { opacity: 0 + slide.overlayOpacity }
                    })
                  ]
                ),
            slide.enableScrollTrigger
              ? _c(
                  "div",
                  {
                    staticClass: "hero-banner__scroll-trigger",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.scrollTrigger($event)
                      }
                    }
                  },
                  [
                    _c("icon", {
                      attrs: {
                        "fill-class": _vm.heroSchema.arrowColor,
                        name: "arrow_down",
                        size: "16px"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        }),
        1
      ),
      !_vm.heroSchema.enableTextBox
        ? _c("div", { staticClass: "hero-carousel__controls-container" }, [
            _c(
              "div",
              {
                staticClass: "controls-container",
                class: [
                  _vm.layoutHorizontal,
                  _vm.layoutVertical,
                  _vm.textAlign
                ],
                style: _vm.sliderControlsLayout
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "arrows",
                    style: _vm.sliderControlsLayoutArrows
                  },
                  [
                    _c("icon", {
                      staticClass: "arrow-prev",
                      attrs: {
                        "fill-class": _vm.heroSchema.arrowColor,
                        name: "chevron-left",
                        size: "12px"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.slidePrev($event)
                        }
                      }
                    }),
                    _c("icon", {
                      staticClass: "arrow-next",
                      attrs: {
                        "fill-class": _vm.heroSchema.arrowColor,
                        name: "chevron-right",
                        size: "12px"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.slideNext($event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "pagination-dots",
                    style: _vm.sliderControlsLayoutArrows
                  },
                  _vm._l(_vm.slides, function(slide, index) {
                    return _c("div", {
                      key: "dot-" + index,
                      staticClass: "dot",
                      class: _vm.dotActive(index),
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.slidePagination(index)
                        }
                      }
                    })
                  }),
                  0
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }